"use strict";

exports.__esModule = true;
exports.ReportFields = ReportFields;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _reactIntl = require("react-intl");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _Time = require("../../Time");
var _ElementLayoutVisibilityControlGroup = require("../../ConfigurableLayout/ElementEditor/ControlGroups/ElementLayoutVisibilityControlGroup");
var _styles = require("../../ConfigurableLayout/common/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Fields for ReportElement.
 */
function ReportFields(props) {
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: /*#__PURE__*/_react["default"].createElement(_styles.LayoutElementTitle, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ReportFields.timeRangeKind.label",
      defaultMessage: "Time Range"
    })),
    helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ReportFields.timeRangeKind.helperText",
      defaultMessage: "The type of time range selector to show for this report."
    })
  }, /*#__PURE__*/_react["default"].createElement(_Time.TimeRangeKindSelector, {
    value: element.props.timeRangeKind || "",
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "timeRangeKind", e.target.value);
    }
  })), /*#__PURE__*/_react["default"].createElement(_ElementLayoutVisibilityControlGroup.ElementLayoutVisibilityControlGroup, {
    elementEditor: elementEditor,
    path: path,
    element: element
  }), /*#__PURE__*/_react["default"].createElement(_ConfigurableLayout.ElementCanvasSizeControlGroup, {
    elementEditor: elementEditor,
    path: path,
    element: element
  }), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ReportFields.rowCount.label",
      defaultMessage: "Rows"
    }),
    helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ReportFields.rowCount.helperText",
      defaultMessage: "The number of horizontal rows."
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "ReportFields.slider.rows"
  }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
    labelRenderer: false,
    min: 3,
    max: 48,
    value: element.props.rowCount || 12,
    onChange: function onChange(value) {
      return elementEditor.setProp(path, "rowCount", value);
    }
  }))), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ReportFields.columnCount.label",
      defaultMessage: "Columns"
    }),
    helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ReportFields.columnCount.helperText",
      defaultMessage: "The number of vertical columns"
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "ReportFields.slider.columnCount"
  }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
    labelRenderer: false,
    min: 3,
    max: 48,
    value: element.props.columnCount || 12,
    onChange: function onChange(value) {
      return elementEditor.setProp(path, "columnCount", value);
    }
  }))));
}